import ApiJobCategory from 'types/api/JobCategory';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import JobCategory from 'models/JobCategory';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {}
export const list = async (params?: ListParams): Promise<ListCollection<JobCategory>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobCategories, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.JobCategories];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiJobCategory) => new JobCategory(element)),
        meta: resource.meta,
    };
};

export interface SingleParams {
    slug: string;
}
export const single = async (params: SingleParams): Promise<JobCategory> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobCategory, params),
    });

    const data = response?.payload?.data;
    const resource: ApiJobCategory = data && data[ApiResources.JobCategory];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new JobCategory(resource);
};
